import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {EmployeeInvitation} from '../model/employee-invitation.model';
import {AuthenticationService} from '../../authentication/authentication.service';
import {EMPLOYEE_INVITATIONS_URL} from '../../api-config';

@Injectable({
  providedIn: 'root'
})
export class EmployeeInvitationService {

  constructor(private httpClient: HttpClient, private authenticationService: AuthenticationService) { }

  public patchTwoFactorCode(invitationId: string, twoFactorCode: string): Observable<EmployeeInvitation> {
    return this.httpClient.patch<EmployeeInvitation>(EMPLOYEE_INVITATIONS_URL.replace('{userId}', this.authenticationService.getUserId())
      + invitationId, {twoFactorCode});
  }
}
